module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fm01t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("President Samuel Baker")])]), _vm._v(" "), _c('p', {
    staticClass: "fm01"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("and")])]), _vm._v(" "), _c('p', {
    staticClass: "fm01"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Vice President Daniel Eastman")])]), _vm._v(" "), _c('p', {
    staticClass: "fm101"
  }, [_vm._v("were elected to office on")]), _vm._v(" "), _c('p', {
    staticClass: "fm01"
  }, [_vm._v("November 4, 1984.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1246958","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Fm02.vue
// module id = 81
// module chunks = 0